import rehypePrismGenerator from 'rehype-prism-plus/generator';
import { refractor } from 'refractor/lib/common.js';
import docker from 'refractor/lang/docker.js';
import graphql from 'refractor/lang/graphql.js';
import http from 'refractor/lang/http.js';
import nginx from 'refractor/lang/nginx.js';
import powershell from 'refractor/lang/powershell.js';
import toml from 'refractor/lang/toml.js';
import uri from 'refractor/lang/uri.js';

[uri, http, docker, graphql, nginx, powershell, toml].forEach((language) => {
  refractor.register(language);
});

export const rehypePrism = rehypePrismGenerator(refractor);
